module.exports = __webpack_public_path__ + "img/light_brown.22ebb0bc.svg";